import {
  defaultDonor,
  defaultTrader,
  Donor,
  DonorFromJSON,
  exists,
  Trader,
  TraderFromJSON
} from '@/api'

export interface BibliographySetManagementInfo {
  id: number
  bibliographySetId: number
  continuation: string
  notArrived: string
  openBookbinding: string
  bookClaim: string
  shelfPlace: string
  traderCode: Trader
  donorCode: Donor
  missingNumberText: string
  retitleBefore: string
  retitleAfter: string
  contractYear: string
  holdingYear: string
  holdingVolume: string
  needBookbinding: string
  memo1: string
  memo2: string
  memo3: string
  memo4: string
  memo5: string
  memo6: string
  memo7: string
  memo8: string
  memo9: string
  revision: number
}

export const defaultBibliographySetManagementInfo = (): BibliographySetManagementInfo => ({
  id: 0,
  bibliographySetId: 0,
  continuation: '',
  notArrived: '',
  openBookbinding: '',
  bookClaim: '',
  shelfPlace: '',
  traderCode: defaultTrader(),
  donorCode: defaultDonor(),
  missingNumberText: '',
  retitleBefore: '',
  retitleAfter: '',
  contractYear: '',
  holdingYear: '',
  holdingVolume: '',
  needBookbinding: '',
  memo1: '',
  memo2: '',
  memo3: '',
  memo4: '',
  memo5: '',
  memo6: '',
  memo7: '',
  memo8: '',
  memo9: '',
  revision: 0
})

export function BibliographySetManagementInfoFromJSON(
  json: any
): BibliographySetManagementInfo {
  return {
    id: exists(json, 'id') ? json.id : 0,
    bibliographySetId: exists(json, 'bibliography_set_id')
      ? json.bibliography_set_id
      : '',
    continuation: exists(json, 'continuation') ? json.continuation : '',
    notArrived: exists(json, 'not_arrived') ? json.not_arrived : '',
    openBookbinding: exists(json, 'open_bookbinding')
      ? json.open_bookbinding
      : '',
    bookClaim: exists(json, 'book_claim') ? json.book_claim : '',
    shelfPlace: exists(json, 'shelf_place') ? json.shelf_place : '',
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    donorCode: exists(json, 'donor_code')
      ? DonorFromJSON(json.donor_code)
      : defaultDonor(),
    missingNumberText: exists(json, 'missing_number_text')
      ? json.missing_number_text
      : '',
    retitleBefore: exists(json, 'retitle_before') ? json.retitle_before : '',
    retitleAfter: exists(json, 'retitle_after') ? json.retitle_after : '',
    contractYear: exists(json, 'contract_year') ? json.contract_year : '',
    holdingYear: exists(json, 'holding_year') ? json.holding_year : '',
    holdingVolume: exists(json, 'holding_volume') ? json.holding_volume : '',
    needBookbinding: exists(json, 'need_bookbinding')
      ? json.need_bookbinding
      : '',
    memo1: exists(json, 'memo1') ? json.memo1 : '',
    memo2: exists(json, 'memo2') ? json.memo2 : '',
    memo3: exists(json, 'memo3') ? json.memo3 : '',
    memo4: exists(json, 'memo4') ? json.memo4 : '',
    memo5: exists(json, 'memo5') ? json.memo5 : '',
    memo6: exists(json, 'memo6') ? json.memo6 : '',
    memo7: exists(json, 'memo7') ? json.memo7 : '',
    memo8: exists(json, 'memo8') ? json.memo8 : '',
    memo9: exists(json, 'memo9') ? json.memo9 : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
